// extracted by mini-css-extract-plugin
export default {"tabs":"MFsR","full-width":"ApRL","fullWidth":"ApRL"};